import { useNavigate, useParams } from 'react-router-dom'

import { Button } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import { useDestroyCategory } from 'modules/trainings/hooks/Categories/useDestroyCategory'

const DeleteCategory = () => {
  const { destroyCategory } = useDestroyCategory()
  const { id } = useParams()
  const { navigation } = useNavigation()
  const navigate = useNavigate()
  const back = () => navigate(navigation.trainings.list.categories.fullPath())

  const onSubmit = async () => {
    const response = await destroyCategory({ id: String(id) })
    const handled = handleResult(response, () => {
      app.setFlash({
        type: 'wrong',
        message: i18n.t('trainings.tags.modal.delete.result_toast.error'),
      })
    })

    if (handled.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('trainings.tags.modal.delete.result_toast.success'),
      })
      back()
    }
  }

  return (
    <Modal
      title={i18n.t('trainings.tags.modal.delete.title')}
      description={i18n.t('trainings.tags.modal.delete.subtitle')}
      onSubmit={onSubmit}
      onClose={back}
      footer={
        <>
          <Button.Router to={navigation.trainings.list.categories.fullPath()}>
            {i18n.t('trainings.tags.modal.delete.cancel_button_label')}
          </Button.Router>
          <Button type="negative" submit>
            {i18n.t('trainings.tags.modal.delete.confirm_button_label')}
          </Button>
        </>
      }
    ></Modal>
  )
}

export default DeleteCategory
